import { seperate } from '@rategravity/frontend/modules/numbers';
import React from 'react';
import Card from '../components/card';
import { MIN_DOWN_PAYMENT_SIZES } from '../modules/down-payment-evaluation';
import { LoanCard } from './card-lenses';

const DownPaymentTooSmallCard = ({ ruleset, model, ...props }) => {
  const minSize = MIN_DOWN_PAYMENT_SIZES[ruleset];
  const title = `Head's up! You'll need ${
    minSize !== undefined
      ? `at least $${seperate(Math.floor(model.get('purchasePrice') * minSize))} for a`
      : 'a larger'
  } down payment to qualify for this mortage.`;
  return (
    <Card buttonType="none" title={title} {...props}>
      <br />
      Your minimum down payment amount is based on the information you provided about the purchase
      price, occupancy and property types, as well as your eligibility for certain loan programs. To
      continue, revise your down payment or adjust another input. To read more about minimum down
      payments click{' '}
      <a
        href="http://www.freddiemac.com/singlefamily/factsheets/sell/ltv_tltv.htm"
        className="link__hover--yellow"
        target="_blank"
        rel="noreferrer"
      >
        here
      </a>
      .
    </Card>
  );
};

DownPaymentTooSmallCard.id = 'down-payment-too-small';
DownPaymentTooSmallCard.completed = () => false;

export const DownPaymentTooSmall = (ruleset) =>
  LoanCard(
    DownPaymentTooSmallCard,
    // Ids represent each ruleset combination for easier mixpanel logging
    `${DownPaymentTooSmallCard.id}-${ruleset}`,
    { ruleset }
  );



// WEBPACK FOOTER //
// ./src/cards/down-payment-too-small.js